import axios from "axios";

const allowPublicVoting = true;
const token = localStorage.getItem("token");

export default class FactCheckerApi {


    static getBaseUrl() {
        //return "https://dun.vydeo.xyz/fact_checker";
        return "https://dun.vydeo.xyz/iter3/fact_checker";
        //return "http://localhost:5003/fact_checker";
    }

    static checkText(text, allowPublicVoting, token) {
        if (!localStorage.getItem("token")) {
            return
        }
  
        return axios.post(FactCheckerApi.getBaseUrl() + "/check_texts", {texts: [{"text": text, "index":0}], allow_public_voting: allowPublicVoting, captcha:token},
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                }
            }
        );
        // return axios.post("https://dunderdebunk-backend-production.up.railway.app/fact_checker/upload", { text:text },
        //     {
        //         headers: {
        //           'Content-Type': 'application/json',
        //           Authorization: `Bearer ${localStorage.getItem("token")}`,         
        //                }});

    }

    static checkUrl(url, allowPublicVoting, token) {
        if (!localStorage.getItem("token")) {
            return
        }
        return axios.post(FactCheckerApi.getBaseUrl() + "/check_url", { url: url, allow_public_voting: allowPublicVoting, captcha: token },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                }
            });
    }
    static getWebsiteInfo(url) {
        return axios.post(FactCheckerApi.getBaseUrl() + "/get_website_info", { url: url },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                }
            });
    }
}